import React, { Component } from 'react';
import '../css/Contactos.css';
import GoogleMapReact from 'google-map-react';
import facebook from '../img/facebook.png';
import twitter from '../img/twitter.png';
import youtube from '../img/youtube.png';
const AnyReactComponent = ({ text }) => (
  <div className="Component1">
    <span style={{ color: 'red' }} className="spanComponent" class="glyphicon glyphicon-map-marker" aria-hidden="true"></span>

    {text}
  </div>
);


class Contactos extends Component {
  static defaultProps = {
    center: {
      lat: -12.136051,
      lng: -77.002228
    },
    zoom: 13
  };

  render() {
    return (
      <div id="contactos-final">
        <div className='fondo-contactos'>
          <div className="panelContactos">
            <h1 className="tituloContactosinicio">Nosotros te ayudamos</h1>
            <hr className="barraColores"></hr>
          </div>
        </div>
        <div className="contenedor-contactos">
          <h1>Contáctenos</h1>
          <hr className="barracolores2"></hr>
        </div>
        <div className="cuadroContactos">
          <div className="content1">
            <h4 className="tituloContactos">Contacte con nosotros sobre cualquier cosa relacionada</h4>
            <h4 className="tituloContactos2">con nuestra empresa o servicios.</h4>
            <form  target="_blank" id="contact-form" action="https://formspree.io/lcarrascol@noisystems.com" method="POST" autoComplete="off">
              <div class="form-group">
                <span className="formcontactos">Empresa     :</span>
                <input name="empresa" className="inputcontactos1" type="text" class="form-control" required/>
              </div>
              <div class="form-group">
                <span className="formcontactos">Nombres     :</span>
                <input name="nombre" className="inputcontactos2" type="text" class="form-control" required/>
              </div>
              <div class="form-group">
                <span className="formcontactos">E-mail      :</span>
                <input name="email" className="inputcontactos3" type="email" class="form-control" required/>
              </div>
              <div class="form-group">
                <span className="formcontactos">Teléfono    :</span>
                <input name="telefono" className="inputcontactos4" type="number" class="form-control" required/>
              </div>
              <div class="form-group">
                <span className="formcontactos">Asunto      :</span>
                <input name="asunto" className="inputcontactos5" type="text" class="form-control" required/>
              </div>
              <div class="form-group">
                <span className="formcontactos">Consulta    :</span>
                <textarea style={{resize:"none"}} name="consulta" className="inputcontactos6" class="form-control" rows="5" id="comment" required/>
              </div>
              <button id='envio'  type="submit" class="btn btn-primary btn-block">
                Enviar
              </button>
              <input type="hidden" name="_subject" id="_subject" value="Contacto" />
              <input type="hidden" name="_language" value="es" />
              <input type="hidden" name="_next" value="https://noisystems.com/#contactos-final" />
              <input type="hidden" name="_subject" value="Nuevo Envío!" />
            </form>
          </div>
          <div className="ContactosPanelRegistro">
            <h3 className="tituloRegistro">NOI SYSTEMS</h3>
            <div className="conteinerProtegido">
              <div className="campusProtegido1">
                <span id="colorContactos1" className="glyphicon glyphicon-map-marker" aria-hidden="true"></span>
                <p className="direccionContactos">Av. Vicus cdra. 1 - B86 Urb. La Capullana </p>
                <p className="postalContactos">- Surco - Lima</p>
              </div>
              <div className="segundariaContactos">
                <span id="colorContactos2" className="glyphicon glyphicon-earphone" aria-hidden="true"></span>
                <p className="direccionContactos">637-1818</p>
              </div>
              <div className="segundariaContactos">
                <span id="colorContactos3" className="glyphicon glyphicon-phone" aria-hidden="true"></span>
                <p className="direccionContactos">997-928-544</p>
              </div>
              <div className="segundariaContactos">
                <span id="colorContactos4" className="glyphicon glyphicon-envelope" aria-hidden="true"></span>
                <p className="direccionContactos">lcarrascol@noisystems.com</p>
              </div>
            </div>

            <div className="googleMap">
              <GoogleMapReact
                bootstrapURLKeys={{ key: '' }}
                defaultCenter={this.props.center}
                defaultZoom={this.props.zoom}
              >
                < AnyReactComponent
                  lat={-12.136051}
                  lng={-77.002228}
                  text={' Noi Systems'}
                />
              </GoogleMapReact>
            </div>
          </div>
        </div>
        <div className="contactosprimarios">
          <p className="privatecontactos"> Copyright © 2018 NOI SYSTEMS.</p>
          <div className="barraprivatecontactos">
            <a href='https://www.facebook.com/NoiSystems' id="buttonfacebook" target="_blank">
              <img src={facebook}></img>
            </a>
            <a href='#' id="buttontwhitter">
              <img src={twitter}></img>
            </a>
            <a href='https://www.youtube.com/channel/UCh49lUvA5-GZj4nkWidHQkw' id="buttonyoutube" target="_blank">
              <img src={youtube}></img>
            </a>
          </div>
          <p className="reservadosParrafo">Todos los derechos reservados.</p>
        </div>
        <div className="contenidoFinal">
          <div className="contentCampo1">
            <p className="contentparrafo1">
              Oficina: Av. Vicus cdra. 1 - B86 Urb. La Capullana - Surco - Lima
            </p>
            <p className="contentparrafo1">
              Central Telefónica: 637-1818 | Email: lcarrascol@noisystems.com
            </p>
            <p className="contentparrafo1">
              LIMA - PERU
            </p>
          </div>

        </div>
      </div>
    )
  }

}
export default Contactos;


// WEBPACK FOOTER //
// ./src/components/Contactos.jsx